module.exports = __webpack_public_path__ + "static/media/wiserr.13bbecbe.png";